const requiredValidator = (value, includeZero = false) => {
  if (includeZero && +value === 0) return undefined;
  if (!value) return 'Required';
  return undefined;
};

export default requiredValidator;
